import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
} from "@mui/material";
import React from "react";
import "./ProductCard.css";


/**to display productlist into responsive cards
 * map the product list inside a Grid parent container component
 * destructre the product values to its names
 * return a child grid with responsive breakpoint values to it
 * inside attach the card items
 * 
 */
const ProductCard = ({ product, handleAddToCart }) => {

  return (
          <Card className="card">
          <CardContent >
          <CardMedia 
          component="img"
      height="194"
      image={product.image} 
      alt={product.name}/>
      <Typography variant="h5" component="div">
        {product.name}
      </Typography>
      <Typography variant="h5" component="div">
        ${product.cost}
      </Typography>
      <Rating name="half-rating-read" defaultValue={product.rating} precision={0.5} readOnly />
      </CardContent>
      <CardActions >
      <Button  variant="contained" fullWidth  onClick={ handleAddToCart}>
        <AddShoppingCartOutlined />ADD TO CART</Button>
      </CardActions>
    </Card>
        )
     

 
  
};

export default ProductCard;
